import React, { useState } from "react";
import { Link } from "react-router-dom";
import { limitText } from "../../Utility/Utility";
import YouTube from "react-youtube";
import { Img } from "../../Components/UI/UI";

export const TestimonialsItem = (props) => {
  const desc = props.desc != undefined ? props.desc : "";
  const imgVideo = props.imgVideo != undefined ? props.imgVideo : "";
  const id = props.id != undefined ? props.id : "";
  const vidId = props.vidId != undefined ? props.vidId : "";
  const name = props.name != undefined ? props.name : "";
  const country = props.country != undefined ? props.country : "";
  const [isHover, setIsHover] = useState(false);
  const [isClicked, setIsClicked] = useState(false);

  let cancelCoverCss;

  const youTubeOptions = {
    playerVars: {
      // https://developers.google.com/youtube/player_parameters
      autoplay: 0,
      muted: 1,
      controls: 1,
      loopPlaylists: true,
      loop: 1,
      playlist: props.vidId,
    },
  };

  if (isClicked) {
    cancelCoverCss = " ac-cover-hide";
  } else {
    cancelCoverCss = " ";
  }

  return (
    <div
      className={
        "ac-wrapper-testimonialsitem ac-wrapper-testimonialsitem-" + id
      }
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
    >
      <div className="ac-pic-video-content">
        <div className="ac-wrapper-name">
          <div className="ac-innerwrapper-name">
            <span>
              {name}
              <br />
              {country}
            </span>
          </div>
        </div>
        <button
          className={"ac-pic-wrapper" + cancelCoverCss}
          onClick={(event) => {
            setIsClicked(true);
            event.target.playVideo();
          }}
        >
          <Img desktopImg={imgVideo} imgCss={"ac-cover-video-img"} />
          <Img
            desktopImg={"Resources/White-play.svg"}
            imgCss={"ac-play-icon"}
          />
        </button>
        <div className="responisve-iframe">
          <YouTube
            videoId={vidId}
            opts={youTubeOptions}
            onReady={(event) => {
              event.target.mute();
              // event.target.playVideo();
              event.target.stopVideo();
            }}
          />
        </div>
      </div>
      <p>{limitText(desc, 100)}</p>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/Components/Testimonials/TestimonialsItem.js